import { Image } from 'antd';
import arrow from '../../../assets/images/about/introduction/arrow.png'

import styles from  './style.module.scss'

const introductionList = [
    {
        title: '使命',
        name: '让城市更安全，让政府更高效'
    },
    {
        title: '愿景',
        name: '打造信息领域的国之重器'
    },
    {
        title: '核心价值观',
        name: '客户导向、工匠精神、自主创新、诚信敬业'
    }
];

const Introduction = () => {
    return (
      <div className={styles['introduction-wrapper']}>
        <p className={styles['title']}>
          南京烽火星空通信发展有限公司
        </p>

        <div className={styles['content']}>
          <p>
            南京烽火星空通信发展有限公司是中国信科大数据治理和网络信息安全产业的核心企业，依托自主可控的大数据智能化技术，研发了面向网络安全、公共安全、智慧城市三大领域的相关产品和解决方案，致力于打造集资源、能力、服务、应用于一体的智能化大数据系列产品，推动数据化服务向各业务领域拓展延伸，助力用户构建以大数据智能应用为核心的业务新生态。
          </p>
        </div>

        <div className={styles['introduction-container']}>
          {introductionList.map((item, index) => (
            <div
              className={styles['introduction-item']}
              key={index}
            >
              <div className={styles['item-title']}>
                <Image
                  src={arrow}
                  preview={false}
                  width={14}
                  height={12}
                />
                <span>{item.title}</span>
              </div>
              <div className={styles['item-slogan']}>
                {item.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
}
export default Introduction